import { useEffect, useState } from "react";
import { useSplitTreatments } from "@splitsoftware/splitio-react";

import { flags } from "./treatments";

export const FlagScript = () => {
  const splitFlags = useSplitTreatments({ names: Object.values(flags) });
  const [flagsWithMeta, setFlagsWithMeta] = useState([]);

  useEffect(() => {
    const treatmentsWithMeta = [];
    for (const [name, value] of Object.entries(splitFlags.treatments)) {
      treatmentsWithMeta.push({
        name,
        value: value.treatment === "on",
      });
    }
    setFlagsWithMeta(treatmentsWithMeta);
  }, [splitFlags.treatments]);

  return (
    <script data-clarity-flag-overrides data-testid="flag-script" type="application/json">
      {JSON.stringify(flagsWithMeta)}
    </script>
  );
};
